import React, { FC, HTMLAttributes } from "react";

import { NonPreviewableSVG } from "@epignosis_llc/gnosis/icons";

import { thumbnailFallbackStyles } from "@components/Cards/FileCard/components/styles";

import { useApplyTranslations } from "@hooks";

import { IconType } from "types/common";

type ThumbnailFallbackProps = {
  icon?: IconType;
  height?: number;
  ariaLabel?: string;
};

const ThumbnailFallback: FC<ThumbnailFallbackProps & HTMLAttributes<HTMLDivElement>> = ({
  icon,
  height = 40,
  ariaLabel,
}) => {
  const { t } = useApplyTranslations();
  const Icon = icon ?? NonPreviewableSVG;

  return (
    <div
      css={thumbnailFallbackStyles}
      aria-label={ariaLabel ?? t("a11y.general.noThumbnail")}
      role="img"
    >
      <Icon height={height} />
    </div>
  );
};

export default ThumbnailFallback;
